import { request } from "../../apis";

export const apiGetMessageUnread = (): any =>
  request("get", `/api/user/order/message/unread`, null, true);
